/* eslint-disable */


import Vue from "vue";

import { VueAuthenticate } from "vue-authenticate";
import axios from "axios";
import store from "../store";
import Raven from 'raven-js';
import router from "../routes";


class Kuvera {
  constructor() {}

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      s4() +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      s4() +
      s4()
    );
  }

  delay(t, v) {
    return new Promise(function(resolve) {
      setTimeout(resolve.bind(null, v), t);
    });
  }

  axios_wrapper(axios_config, retry = 0) {
    return axios(axios_config)
      .then(r => r.data)
      .catch(err => {
        if (err.response) {
          Vue.console.error("[kuvera] makeRequest: API responded error " , err.response.status);
          Vue.console.error(JSON.stringify(err.response));

          if (err.response.status == 401) {

            if(err.response.data && Array.isArray(err.response.data.errors) && err.response.data.errors.includes('Not Authenticated') ){
             return store.dispatch("logout").then(() => {
                if (process.env.NODE_BUILD === "mobile") {
                  window.plugins.googleplus.disconnect();
                } else {
                  window.location.href = "/login"; // Hard redirect. page reload
                }
              });
            }

            // user auth session expired
            let authCode = err.response.data && err.response.data.auth_code;
            if (authCode) store.commit("SET_AUTH_CODE", authCode);

            return redirectByAuthCodeStatus({authCode,err});

          } else if (err.response.status == 400) {
            Vue.console.error("[kuvera] makeRequest: Responsed with 400 error");
            return Promise.reject({ code: 400, status: err.response.data });
          } else if (err.response.status == 403) {
            Vue.console.error("[kuvera] makeRequest: Responsed with 403 error");
            return Promise.reject({ code: 403, status: err.response.data });
          } else if (err.response.status == 503) {
            Vue.console.error("[kuvera] makeRequest: Responsed with 503 error");
            let uptime = null;
            if (err.response.headers && err.response.headers["retry-after"]) {
              uptime = err.response.headers["retry-after"];
            }
            return Promise.reject({
              code: 503,
              status: "service unavailable",
              uptime: uptime
            });
          } else if (err.response.status >= 500) {
            Vue.console.error("[kuvera] makeRequest: Responsed with " + err.response.status + " error");
            Vue.console.error(JSON.stringify(err.response));
            if (axios_config.method.toLowerCase() == "get") {
              Vue.console.error("[kuvera] makeRequest: We may retry couple of times.");
              if (retry < 5) {
                if (Vue.config.RAVEN_TOKEN && retry > 3) {
                  Raven.captureException(`API (5xx) retry number ${retry} for url ${axios_config.url} with method ${axios_config.method}`);
                }
                return delay(2 ** retry * 1000).then(() => this.axios_wrapper(axios_config, retry + 1));
              }
            }
          }
        } else if (err.request) {
          Vue.console.error("err.request : " + JSON.stringify(err.request));
          if (err.request.__raven_xhr && axios_config.method.toLowerCase() == "get") {
            Vue.console.error("API __raven_xhr. We may retry couple of times.");
            if (err.request.__raven_xhr.status_code == 0 && retry < 5) {
              return delay(1000).then(() => this.axios_wrapper(axios_config, retry + 1));
            }
          }
        } else {
          Vue.console.error("errro:catch");
          Vue.console.error(err);
        }
        return Promise.reject({ code: 500, status: "server down" });
      });
  }

  makeRequest(method_type, uri, body_params = {}) {
    // if (changed_auth_token()) {
    //   Vue.console.info("Portfolio/User changed: Redirecting user to dasboard");
    //   window.location.href = "/";
    //   return Promise.reject({ code: 405, status: "auth token changed" });
    // }
    console.log("uri makeRequest",uri)
    // Vue.console.info("makeRequest: fetching " + uri);
    let url = null;

    // All V3 api's are provided by el-dorado whereas others are provided by castle-rock
    if (uri.match(/v3/i)) {
      url = Vue.config.EL_DORADO_API_URL + uri;
    } else if (uri.match(/admin/i)) {
      if (window.location.pathname.match(/ku/i))
       url = Vue.config.EL_DORADO_API_URL + uri;
      else {
        url = Vue.config.EL_DORADO_API_URL + uri;
      }
    } 
    else if (uri.match(/wp-json/i) ){
      url = 'https://kuvera.in/blog' + uri;
    }
    else {
      url = Vue.config.CASTLE_ROCK_API_URL + uri;
    }

    let url_params = {};
    url_params.v = Vue.config.VERSION;

    // Vue.console.info(
    //   "makeRequest: calling " + method_type + " request on " + url
    // );

    let axios_config = {
      method: method_type,
      url: url
    };

    if (url.match(/\.pdf$/i) || url.match(/\.csv$/i)) {
      // set the responseType as blob if this is a csv or pdf file
      axios_config.responseType = "blob";
      //sending blob type request
      // randomize the query parameter so result is not cached
      url_params.rand = (Math.random() * 1000000000).toFixed(0).toString();
    }

    if (method_type == "post" || method_type == "put") {
      axios_config.data = body_params;
      axios_config.params = url_params;
    } else {
      url_params = Object.assign(url_params, body_params);
      axios_config.params = url_params;
    }

    return this.axios_wrapper(axios_config);
  }

  isSuperAdmin() {
    return (
      process.env.NODE_ENV == "development" ||
      window.location.hash == "#savanahtropical"
    );
  }

  supportRequest(args) {
    var url = "/api/v3/support.json";
    return this.makeRequest("post", url, args);
  }

  uploadFile(file, type) {
    let formdata = new FormData();
    formdata.append("attachment", file);
    formdata.append("type", type);

    let url = "/api/v3/file_upload.json";
    return this.makeRequest("post", url, formdata);
  }

  uploadImage(data) {
    let url = "/api/v3/image_upload.json";
    return this.makeRequest("post", url, data);
  }

  getUrlToken() {
    return this.makeRequest("get", "/api/v3/user/get_token.json");
  }

  adminInfo() {
    let url = "/admin/adfes433fkdfggs343434/admin.json";
    return this.makeRequest("get", url);
  }

  adminNFO() {
    let url = "/admin/adfes433fkdfggs343434/reports/nfo.csv";
    return this.makeRequest("get", url);
  }

  adminDeactived() {
    let url = "/admin/adfes433fkdfggs343434/reports/deactivated.csv";
    return this.makeRequest("get", url);
  }

  adminRedeemTradesofToday(date) {
    let url = "/admin/adfes433fkdfggs343434/trades/redeemed/" + date + ".csv";
    return this.makeRequest("get", url);
  }

  adminFolioReport() {
    let url = "/admin/adfes433fkdfggs343434/folios/list.csv";
    return this.makeRequest("get", url);
  }

  adminReceivedFunds(params) {
    let url = "/admin/adfes433fkdfggs343434/fund_confirmations.csv";
    return this.makeRequest("get", url, params);
  }

  adminEmailListReport(date) {
    let url =
      "/admin/adfes433fkdfggs343434/reports/email_list/" + date + ".csv";
    return this.makeRequest("get", url);
  }

  adminEmailSummaryReport() {
    let url = "/admin/adfes433fkdfggs343434/reports/email/summary.json";
    return this.makeRequest("get", url);
  }

  adminTrades(trade_type) {
    let url = "/admin/adfes433fkdfggs343434/trades/" + trade_type + ".csv";
    return this.makeRequest("get", url);
  }

  adminDreamGrowth() {
    let url = "/admin/adfes433fkdfggs343434/reports/dream_growth.csv";
    return this.makeRequest("get", url);
  }

  adminShareGrowth() {
    let url = "/admin/adfes433fkdfggs343434/reports/share_growth.csv";
    return this.makeRequest("get", url);
  }

  adminPivotGrowth() {
    let url = "/admin/adfes433fkdfggs343434/reports/pivot.csv";
    return this.makeRequest("get", url);
  }

  adminUserInfo(user_id) {
    let url = "/admin/adfes433fkdfggs343434/users/" + user_id + ".json";
    return this.makeRequest("get", url);
  }

  adminBankTaskCheck(task_id) {
    let url = "/admin/adfes433fkdfggs343434/banks/" + task_id + ".json";
    return this.makeRequest("get", url);
  }

  adminPortfolioTaskCheck(task_id) {
    let url = "/admin/adfes433fkdfggs343434/portfolio/" + task_id + ".json";
    return this.makeRequest("get", url);
  }

  setBankStatus(data) {
    let url = "/admin/adfes433fkdfggs343434/banks/" + data.task_id + ".json";
    return this.makeRequest("post", url, data);
  }

  adminUserList(search_key, type) {
    let url =
      "/admin/adfes433fkdfggs343434/users/search.json?search_key=" +
      search_key +
      "&type=" +
      type;
    return this.makeRequest("get", url);
  }

  adminUserTrades(portfolio_id, ext = ".json") {
    let url = "/admin/adfes433fkdfggs343434/trades/" + portfolio_id + ext;
    return this.makeRequest("get", url);
  }

  adminUserSystematicOrders(portfolio_id, ext = ".json") {
    let url =
      "/admin/adfes433fkdfggs343434/orders/systematic/" + portfolio_id + ext;
    return this.makeRequest("get", url);
  }

  adminUserPlacedOrders(portfolio_id) {
    let url =
      "/admin/adfes433fkdfggs343434/orders/placed/" + portfolio_id + ".json";
    return this.makeRequest("get", url);
  }

  adminUserFolios(portfolio_id, ext = ".json") {
    let url = "/admin/adfes433fkdfggs343434/folios/" + portfolio_id + ext;
    return this.makeRequest("get", url);
  }

  adminUccAudits(portfolio_id) {
    let url =
      "/admin/adfes433fkdfggs343434/portfolio/" + portfolio_id + "/ucc.json";
    return this.makeRequest("get", url);
  }

  adminCas(user_id) {
    let url = "/admin/adfes433fkdfggs343434/users/cas/" + user_id + ".json";
    return this.makeRequest("get", url);
  }

  adminImportRules(user_id) {
    let url =
      "/admin/adfes433fkdfggs343434/users/import_rules/" + user_id + ".json";
    return this.makeRequest("get", url);
  }

  adminGoals(portfolio_id) {
    let url =
      "/admin/adfes433fkdfggs343434/users/goals/" + portfolio_id + ".json";
    return this.makeRequest("get", url);
  }

  adminUserHoldings(portfolio_id) {
    let url =
      "/admin/adfes433fkdfggs343434/folios/holdings/" + portfolio_id + ".json";
    return this.makeRequest("get", url);
  }

  adminTaskList() {
    let url = "/admin/adfes433fkdfggs343434/admin-tasks.json";
    return this.makeRequest("get", url);
  }

  adminNachVerfiyList() {
    let url = "/admin/adfes433fkdfggs343434/mandates.json";
    return this.makeRequest("get", url);
  }

  updateNachProcessedFile(data) {
    let url = `/admin/adfes433fkdfggs343434/mandates/${data.id}.json`;
    return this.makeRequest("put", url, data);
  }

  adminCoinsReport() {
    let url = "/admin/adfes433fkdfggs343434/reports/coin_report.csv";
    return this.makeRequest("get", url);
  }

  approveNachFile(id) {
    let url = `/admin/adfes433fkdfggs343434/mandates/${id}/approve.json`;
    return this.makeRequest("post", url);
  }

  rejectNachFile(data) {
    let url = `/admin/adfes433fkdfggs343434/mandates/${data.id}/reject.json`;
    return this.makeRequest("post", url, data);
  }

  getBankMasterList() {
    var url = "/admin/adfes433fkdfggs343434/bank/master.json";
    return this.makeRequest("get", url);
  }
  getEmailHistory(emailid) {
    var url =
      "/admin/adfes433fkdfggs343434/reports/email/details.json?email=" +
      emailid;
    return this.makeRequest("get", url);
  }

  getTradeTagList() {
    var url = "/admin/adfes433fkdfggs343434/trades/error.json";
    return this.makeRequest("get", url);
  }

  saveTradeTag(data) {
    var url = "/admin/adfes433fkdfggs343434/trades/error/update.json";
    return this.makeRequest("put", url, data);
  }

  updateNewsletterStatus(data) {
    var url = "/admin/adfes433fkdfggs343434/users/newsletter_subscribe.json";
    return this.makeRequest("put", url, data);
  }

  getAdminCasRequestedEmails(data) {
    const url = `/admin/adfes433fkdfggs343434/cas_email.json`;
    return this.makeRequest(`get`, url, data);
  }

  updateAdminCasRequestedEmails(params) {
    const url = `/admin/adfes433fkdfggs343434/cas_email/${params.id}.json`;
    return this.makeRequest("put", url, params);
  }

  saveCampaignData(params) {
    let url = "/api/v3/users/campaign_data.json";
    return this.makeRequest("post", url, { campaign: params });
  }

  updateUserRefrrealCoins(params) {
    let url = "/admin/adfes433fkdfggs343434/users.json";
    return this.makeRequest("post", url, params);
  }
  fetchReferredUsers() {
    let url = `/admin/adfes433fkdfggs343434/users/referral_users.json`;
    return this.makeRequest("get", url);
  }

  getAuthForCordova(provider, data) {
    var url = "/api/v3/users/auth/" + provider;
    return this.makeRequest("post", url, data);
  }

  getUserInfo() {
    var url = "/api/v3/user/info.json";
    return this.makeRequest("get", url);
  }

  getHdfcLink(params) {
    var url = "/api/v3/user/insurance/hdfc.json";
    return this.makeRequest("get", url, params);
  }

  // getBankInfo() {
  //   var url = '/api/user/bankinfo';
  //   return this.makeRequest('get', url);
  // }

  getHoldings() {
    var url = "/api/v3/portfolio/holdings.json";
    return this.makeRequest("get", url);
  }

  getSmartSwitchHoldings() {
    var url = "/api/v3/portfolio/smart_units.json";
    return this.makeRequest("get", url);
  }

  getFolios(fund_houses) {
    var url = "/api/v3/portfolio/folios";

    if (fund_houses.length) {
      url += "/" + fund_houses.join("|").replace(/\s+/g, "+");
    }
    url += ".json";

    return this.makeRequest("get", url);
  }

  updateFolioDetails(folio_data, id) {
    var url = "/api/v3/portfolio/folio/" + id + ".json";
    return this.makeRequest("put", url, folio_data);
  }

  consolidateFolios(folio_data) {
    var url = '/api/v3/portfolio/consolidate.json';
    return this.makeRequest('put', url, folio_data);
  }

  getAmountPerFolio() {
    var url = "/api/v3/user/folios_amount.json";
    return this.makeRequest("get", url);
  }

  getGoalDistribution(params) {
    var url = "/api/v3/portfolio/goal_distribution.json";
    return this.makeRequest("get", url, params);
  }

  getGoalTagging() {
    var url = "/api/v3/portfolio/goal_tagging.json";
    return this.makeRequest("get", url);
  }

  saveGoalTagging(payload) {
    var url = "/api/v3/portfolio/goal_tagging.json";
    return this.makeRequest("post", url, payload);
  }

  getTrades(data = {}) {
    var url = "/api/v3/portfolio/transactions";

    if (data.type == "csv") {
      url += ".csv";
    } else {
      url += ".json";
    }
    return this.makeRequest("get", url, data);
  }

  getInvalidTrades() {
    return this.getTrades({ bse_status: "INVALID" });
  }

  getGoals() {
    //var url = '/api/v2/user/goals';
    var url = "/api/v3/user/goals.json";
    return this.makeRequest("get", url);
  }

  saveGoal(goal) {
    var url = "/api/v3/goals.json";
    return this.makeRequest("post", url, goal);
  }

  updateGoal(goal) {
    var url = `/api/v3/goals/${goal.id}.json`;
    return this.makeRequest("put", url, goal);
  }

  deleteGoal(goal) {
    var url = `/api/v3/goals/${goal.id}.json`;
    return this.makeRequest("delete", url);
  }

  getPortfolio() {
    var url = "/api/v3/portfolio.json";
    return this.makeRequest("get", url);
  }

  getPortfolioOverview() {
    var url = "/api/v3/portfolio_overview.json";
    return this.makeRequest("get", url);
  }

  // getMandate() {
  //   var url = '/api/v3/portfolio/mandate.json';
  //   return this.makeRequest('get', url);
  // }

  mandate(mandate_info) {
    var url = "/api/v3/portfolio/mandate.json";
    var REST_method = "id" in mandate_info ? "put" : "post";
    return this.makeRequest(REST_method, url, mandate_info);
  }

  getNachFile(mandate_id) {
    var url = `/api/v3/portfolio/nach/generate/${mandate_id}.json`;
    return this.makeRequest("get", url);
  }

  uploadNachFile(data) {
    var url = `/api/v3/mandates/${data.id}/upload_mandate.json`;
    return this.makeRequest("put", url, data);
  }

  mandateDone(params) {
    var url = "/api/v3/portfolio/mandate/callback.json";
    return this.makeRequest("post", url, params);
  }

  getKycStatus(user) {
    // var url = '/kycutils/getkycstatus';
    var url = "/api/v3/kyc/getkyc.json";
    return this.makeRequest("post", url, user);
  }

  getKycFromToken(params) {
    var url = "/api/v3/kyc/signature.json";
    return this.makeRequest("get", url, params);
  }

  saveUserSignature(data) {
    var url = "/api/v3/kyc/signature.json";
    return this.makeRequest("post", url, data);
  }

  accountSetupSignature(data) {
    var url = "/api/v3/kyc/account_setup_signature.json";
    return this.makeRequest("post", url, data);
  }

  getKycData() {
    // TODO : Check to see if all api return value is as expected.
    //var url = '/account/setup/getdata';
    var url = "/api/v3/kyc/getkyc.json";
    return this.makeRequest("get", url);
  }

  getPortfolioKycData() {
    const url = "/api/v3/portfolio/kyc.json";
    return this.makeRequest("get", url);
  }

  updateKycData(data) {
    var url = `/api/v3/kyc/${data.id}.json`;
    return this.makeRequest("put", url, data);
  }

  getNominees() {
    var url = "/api/v3/user/nominees.json";
    return this.makeRequest("get", url);
  }

  createAccount() {
    const url = "/api/v3/portfolio.json";
    return this.makeRequest("post", url);
  }

  updateAccount() {
    var url = "/api/v3/portfolio.json";
    return this.makeRequest("post", url);
  }

  fetchAllBankAccounts() {
    var url = "/api/v3/portfolio/banks.json";
    return this.makeRequest("get", url);
  }

  getIedList(params) {
    const url = "/api/v3/funds/ied/list.json";
    return this.makeRequest("get", url, params);
  }

  getVideoAnalyticsReport(data) {
    var url = "/admin/adfes433fkdfggs343434/reports/video_analytics_report.csv";
    return this.makeRequest("post", url, data);
  }

  getAmcTradeReport(data) {
    var url = "/admin/adfes433fkdfggs343434/reports/amc_trade_report.csv";
    return this.makeRequest("post", url, data);
  }

  getIedLinks(params) {
    const url = "/api/v3/funds/ieds.json";
    return this.makeRequest("get", url, params);
  }

  fetchLinkedBankAccounts() {
    const url = "/api/v3/user/banks";
    return this.makeRequest("get", url);
  }

  saveBankAccount(bank) {
    // pick up only relavent fields to send
    let bank_obj = {};
    let keys = [
      "id",
      "account_number",
      "type_of_account",
      "ifsc",
      "file_bank_acc_proof",
      "doctype_bank_acc_proof",
      "bank",
      "branch",
      "branch_city"
    ];
    keys.forEach(key => (bank_obj[key] = bank[key]));
    var url = "/api/v3/portfolio/banks/" + bank.id + ".json";
    return this.makeRequest("post", url, { bank: bank_obj });
  }

  deleteBankAccount(bank) {
    var url = "/api/v3/portfolio/banks/" + bank.id + ".json";
    return this.makeRequest("delete", url);
  }

  switchPrimaryBankAccount(bank) {
    var url = "/api/v3/portfolio/banks/primary/" + bank.id + ".json";
    return this.makeRequest("post", url, {});
  }

  fetchAllNominees() {
    var url = "/api/v3/user/nominees.json";
    return this.makeRequest("get", url);
  }

  fetchANominee(id) {
    var url = "/api/v3/user/nominee/" + id + ".json";
    return this.makeRequest("get", url);
  }

  saveNominees(nominees) {
    var url = "/api/v3/user/nominees.json";
    return this.makeRequest("post", url, { nominees: nominees });
  }

  // Order related API's
  getOrders() {
    var url = "/api/v3/orders.json";
    return this.makeRequest("get", url);
  }

  createOrder(order) {
    var url = "/api/v3/orders.json";
    return this.makeRequest("post", url, order);
  }

  updateOrder(order) {
    var url = "/api/v3/orders/" + order.id + ".json";
    return this.makeRequest("put", url, order);
  }

  removeOrder(order_id) {
    var url = "/api/v3/orders/" + order_id + ".json";
    return this.makeRequest("delete", url);
  }

  getPlacedOrders(data) {
    var url = "/api/v3/trades/pending.json";
    return this.makeRequest("get", url, data);
  }

  getCompletedOrders() {
    var url = "/api/v3/trades/completed_txns.json";
    return this.makeRequest("get", url);
  }

  updateUserTrades(data) {
    var url = "/api/v3/trades/update/" + data.id + ".json";
    return this.makeRequest("put", url, data);
  }

  cancelOrder(order_ids) {
    var url = "/api/v3/orders/cancel/" + order_ids + ".json";
    return this.makeRequest("post", url);
  }

  getInvalidOrders() {
    var url = "/api/v3/orders/invalid.json";
    return this.makeRequest("get", url);
  }

  hideInvalidOrders(ids) {
    var url = "/api/v3/orders/hide.json";
    return this.makeRequest("post", url, { trade_ids: ids });
  }

  stopSystematicOrder({ ids, otp }) {
    var url = `/api/v3/orders/stop/${ids}.json`;
    return this.makeRequest("post", url, { otp });
  }

  redeemOrder(orders, otp) {
    // var url = "/orderprocess/placeredeemorder";
    var url = "/api/v3/orders/redeem.json";
    if (typeof otp === "undefined") {
      return this.makeRequest("post", url, { orders });
    }
    return this.makeRequest("post", url, { orders, otp });
  }

  switchOrder({ orders, source, otp }) {
    const url = "/api/v3/orders/switch.json";
    return this.makeRequest("post", url, {
      switch: orders,
      source,
      otp
    });
  }

  systematicOrder({ orders, otp }) {
    var url = "/api/v3/orders/systematic.json";
    return this.makeRequest("post", url, { orders, otp });
  }

  placeLumpsumOrder([orders, otp]) {
    var url = "/api/v3/orders/lumpsum.json";
    return this.makeRequest("post", url, {
      order_ids: orders.map(o => o.id),
      otp
    });
  }

  systematicOrders() {
    var url = "/api/v3/orders/systematic.json";
    return this.makeRequest("get", url);
  }

  placeSipOrders({ orders, mandate_id, otp, sip_firstorderflag }) {
    var url =
      "/api/v3/orders/buy_sip/" + orders.map(a => a.id).join("|") + ".json";
    return this.makeRequest("post", url, {
      mandate_id,
      sip_firstorderflag,
      otp
    });
  }

  editSipOrder({ id, amount, folio_no, start_date, mandate_id, otp }) {
    const url = `/api/v3/orders/edit_sip/${id}.json`;
    return this.makeRequest("put", url, {
      amount,
      folio_no,
      start_date,
      mandate_id,
      otp
    });
  }

  pauseSipOrder({ id, start_date, otp }) {
    const url = `/api/v3/orders/skip_sip/${id}.json`;
    return this.makeRequest("put", url, {
      start_date,
      otp
    });
  }

  // buyOrder(data) {
  //   if (data.update) {
  //     var url = "/api/v3/payment/" + data.order_ids + ".json";
  //     return this.makeRequest("put", url, data);
  //   } else {
  //     var url = "/api/v3/payment.json";
  //     return this.makeRequest("post", url, data);
  //   }
  // }

  // systematicOrders() {
  //   var url = "/api/v3/orders/systematic.json";
  //   return this.makeRequest("get", url);
  // }

  saveIpvData(context, ipv_data) {
    var url = "/ipv/completeipv";
    var data = { ipv_data: ipv_data };

    return this.makeRequest(context, "post", url, data).then(response => {
      return response.data;
    });
  }

  getRiskProfile() {
    var url = "/api/v3/risk_profile.json";
    return this.makeRequest("get", url);
  }

  saveRiskProfile(risk) {
    var url = "/api/v3/risk_profile.json";
    return this.makeRequest("post", url, { risk_profile: risk });
  }

  getIfscDetails(ifsc) {
    var url = "/api/v3/bank/details/" + ifsc + ".json";
    return this.makeRequest("get", url);
  }

  getRecommendation(goals_data) {
    var url = "/api/v3/goals/calculate_recommendation.json";
    return this.makeRequest("post", url, goals_data);
  }

  getUserRecommendation(goals, sipData, riskInput) {
    var url = "/api/v3/goals/recommendation.json";
    return this.makeRequest("post", url, {
      goals: goals,
      investMode: "sip",
      investMonth: sipData.monthlyAmount,
      investLump: sipData.curr_lump,
      riskInput: riskInput,
      fromDashboard: 1
    });
  }

  getSipCalculation(goal, handle) {
    var goals_data = { params: goal };
    var url = "";
    if (handle == "sip_imt") {
      url = "/api/v3/goals/sip_recommendation.json";
    } else if (handle == "growmymoney") {
      url = "/api/v3/goals/growmymoney_recommendation.json";
    } else if (handle == "retire_sip") {
      url = "/api/v3/goals/retiresip_recommendation.json";
    }
    return this.makeRequest("post", url, goals_data);
  }

  // Funds API : Please note that the URL's are hardcode right now
  getAllFundsNames() {
    const uri = "/api/v3/funds.json";
    return this.makeRequest("get", uri);
  }

  getCompleteIedList() {
    var url = "/api/v3/funds/ied/list.json";
    return this.makeRequest("get", url);
  }

  getNfoList() {
    var url = "/api/v3/funds/nfo.json";
    return this.makeRequest("get", url);
  }

  getMergedSchemes() {
    var url = "/api/v3/funds/merged.json";
    return this.makeRequest("get", url);
  }

  getTopFundCodes() {
    var url = "/api/v3/funds/top.json";
    return this.makeRequest("get", url);
  }

  getTopRatedCodes() {
    var url = "/api/v3/funds/top_rated.json";
    return this.makeRequest("get", url);
  }

  getTagedFundCodes(tag) {
    var url = `/api/v3/funds/tags/${tag}.json`;
    return this.makeRequest("get", url);
  }

  getFundsInfo(fund_codes) {
    var url = "/api/v3/funds/" + fund_codes.join("|") + ".json";
    return this.makeRequest("get", url);
  }

  getFundsExitLoads(fund_codes) {
    var url = "/api/v3/funds/exit_loads/" + fund_codes.join("|") + ".json";
    return this.makeRequest("get", url);
  }

  getFundNavHistory({ code }) {
    const url = `/api/v3/funds/navs/${code}.json`;
    return this.makeRequest("get", url);
  }

  getBenchmarkNavHistory({ code }) {
    const url = `/api/v3/funds/index_nav/${code}.json`;
    return this.makeRequest("get", url);
  }

  getSupportedBanks() {
    var url = "/api/v3/supported_bank_list.json";
    return this.makeRequest("get", url);
  }

  getCategroyReturns() {
    var url = "/api/v3/funds/category_returns.json";
    return this.makeRequest("get", url);
  }

  getPortfolioPerformanceData(holding_code = "all") {
    holding_code = "all"; // only all supported for now
    var url = "/api/v3/portfolio/performance/" + holding_code + ".json";
    return this.makeRequest("get", url);
  }

  getMockPortfolioPerformanceData(holding_code = "all") {
    holding_code = "all"; // only all supported for now
    var url = "/api/v3/portfolio/dummy_performance/" + holding_code + ".json";
    return this.makeRequest("get", url);
  }

  getInvestedWithAMC() {
    var url = "/api/v3/portfolio/invested_with_amc.json";
    return this.makeRequest("get", url);
  }

  getGoalPerformanceData(goal_handle) {
    goal_handle = "house"; // only house goal supported for now
    var url = "/api/v3/goals/performance/" + goal_handle + ".json";
    return this.makeRequest("get", url);
  }

  forgotPassword(email) {
    var url = "/api/v3/users/reset_password.json";
    var data = {
      email: email
    };
    return this.makeRequest("post", url, data);
  }

  resetPassword(password_data) {
    var url = "/api/v3/users/change_password.json";
    return this.makeRequest("post", url, password_data);
  }

  changePassword(password_data) {
    var url = "/api/v3/users/change_user_password.json";
    return this.makeRequest("post", url, password_data);
  }

  activateAccount(activateAccount_data) {
    var url = "/api/v3/users/activate.json";
    return this.makeRequest("post", url, activateAccount_data);
  }

  addToWaitingList(user_param) {
    var url = "/api/v3/waiting_list/add.json";
    return this.makeRequest("post", url, user_param);
  }

  checkWaitingList(user_param) {
    var url = "/api/v3/waiting_list/status.json";
    return this.makeRequest("post", url, user_param);
  }

  addToNewsletter(email) {
    var url = "/api/v3/newsletter/add.json";
    var data = { newsletter: { email: email } };
    return this.makeRequest("post", url, data);
  }
  setSubscription(status) {
    var url = "/api/v3/newsletter/subscribe.json?subscription_status=" + status;
    return this.makeRequest("put", url);
  }

  requestDeactivation() {
    var url = "/api/v3/users/request_deactivate.json";
    return this.makeRequest("post", url);
  }
  deactivateUser(data) {
    var url = "/api/v3/users/deactivate.json";
    return this.makeRequest("post", url, data);
  }
  unblockUser(data) {
    var url = "/api/v3/users/unblock.json";
    return this.makeRequest("post", url, data);
  }
  updateSocialShare(data) {
    var url = "/api/v3/waiting_list/update.json";
    return this.makeRequest("post", url, data);
  }
  updateMauticEmail(mail_id) {
    var url = "/admin/adfes433fkdfggs343434/mautic_weeklyupdate/" + mail_id + ".json";
    return this.makeRequest("post", url);
  }

  addToFundAnalytics(data) {
    var url = "/api/v3/fund_analytics/add.json";
    return this.makeRequest("post", url, data);
  }

  save_tax_residency(data) {
    var url = "/api/v3/user/tax_residency.json";
    return this.makeRequest("post", url, data);
  }

  userFileTaxes() {
    var data = { channel: "OA" };
    var url = "/api/v3/users/filetaxes.json";
    return this.makeRequest("post", url, data);
  }

  list_users_referred() {
    var url = "/api/v3/user/list_users_referred.json";
    return this.makeRequest("get", url);
  }

  listAffiliatedCodes(code) {
    var url = `/api/v3/affiliate/stats/${code}.json`;
    return this.makeRequest("get", url);
  }

  get_preference(data) {
    var url = "/api/v3/user/get_preference.json";
    return this.makeRequest("post", url, data);
  }

  set_preference(data) {
    var url = "/api/v3/user/set_preference.json";
    return this.makeRequest("post", url, data);
  }

  cams_parse(data) {
    var url = "/api/v3/cams/parse.json";
    return this.makeRequest("post", url, data);
  }

  getCasEmails() {
    var url = "/api/v3/cams/index.json";
    return this.makeRequest("get", url);
  }

  updateCasEmail(data) {
    var url = "/api/v3/cams/update/" + data.id + ".json";
    return this.makeRequest("put", url, data);
  }

  saveCasEmail(data) {
    var url = "/api/v3/cams/create.json";
    return this.makeRequest("post", url, data);
  }

  deleteCasEmail(data) {
    var url = "/api/v3/cams/delete/" + data.id + ".json";
    return this.makeRequest("delete", url);
  }

  triggerCasEmail(data) {
    var url = "/api/v3/cams/trigger.json";
    return this.makeRequest("post", url, data);
  }

  get_AMC_fund_list({ type, amc }) {
    // replace space with +
    amc = amc.replace(new RegExp(" ", "g"), "+");
    var url = `/api/v3/funds/AMC/${amc}.json?type=${type}`;
    return this.makeRequest("get", url);
  }

  bank_proof_protected_to_unprotected(filename, password = null) {
    var url = "/api/v3/bank/bank_proof_change_to_unprotected.json";
    var data = { filename: filename };
    if (password) {
      data["password"] = password;
    }
    return this.makeRequest("post", url, data);
  }

  // coin_transaction(data = null) {
  //   if (data) {
  //     var url = "/api/v3/coins.json";
  //   } else {
  //     var url = "/api/v3/coins/transaction.json";
  //   }
  //   var request_type = data ? "post" : "get";
  //   return this.makeRequest(request_type, url, data);
  // }

  settlement_type_validation(data) {
    var url = "/api/v3/orders/settlement_type_validation.json";
    return this.makeRequest("get", url, data);
  }

  can_place_order(data = {}) {
    var url = "/api/v3/orders/restriction.json";
    return this.makeRequest("post", url, data);
  }

  getCrislDetails(code) {
    var url = `/api/v3/funds/crisil_details2/${code}.json`;
    return this.makeRequest("get", url);
  }

  /**
   * Account Setup Related API Calls
   */

  // Returns a promise
  // that resolves to list of linked users
  getLinkedUsers() {
    const url = "/api/v3/kyc/getkyc.json";
    return this.makeRequest("get", url);
  }

  // Returns a promise
  // That creates a new user linked to current user's account
  createLinkedUser(payload) {
    if (!payload.retry) {
      // initialize retry to 0 in the beginning so backend makes CVL call
      payload.retry = 0;
    }
    const url = "/api/v3/kyc.json";
    return this.makeRequest("post", url, payload).then(kyc => {
      // while retry count is less than 10 and kyc status returned is -2 continue polling
      if (payload.retry < 10 && kyc.kyc_status == -2) {
        payload.retry += 1;
        // Try again after a delay of 5 seconds
        return delay(3000).then(() =>
          this.createLinkedUser({
            dob: payload.dob,
            pan: payload.pan,
            retry: payload.retry
          })
        );
      }
      return kyc;
    });
  }

  /** Returns a promise
   * That assigns a new user to current active account
   * Back-end knows active account
   */
  assignUserToAccount(payload) {
    // payload has user data
    const url = `/api/v3/portfolio/assign.json`;
    return this.makeRequest("post", url, payload);
  }

  assignEmailToAccount(payload) {
    /**
     * payload has email field
     */
    const url = `/api/v3/portfolio/assign.json`;
    return this.makeRequest("post", url, payload);
  }

  setAccountName(payload) {
    /**
     * Set account / portfolio name
     */
    const url = `/api/v3/portfolio/update/${payload.id}.json`;
    return this.makeRequest("put", url, payload);
  }

  archiveAccount(payload) {
    /**
     * Archive an account
     */
    const url = `/api/v3/portfolio/archive/${payload.id}.json`;
    return this.makeRequest("post", url);
  }

  // Returns a promise
  // That lists all accounts linked to the current account
  getLinkedAccounts() {
    const url = "/api/v3/portfolio/list.json";
    return this.makeRequest("get", url);
  }

  /**
   * Gets Portfolio-wise returns
   */
  getAccountReturns() {
    const url = "/api/v3/user/accounts/returns_2.json";
    return this.makeRequest("get", url);
  }

  // Returns a promise
  // that creates an account and links the account to current account
  createLinkedAccount(payload) {
    const url = "/api/v3/portfolio/new.json";
    return this.makeRequest("post", url, payload);
  }

  // Returns a promise
  // that switches current account to another account
  switchAccount(id) {
    const url = `/api/v3/portfolio/switch/${id}.json`;
    return this.makeRequest("post", url);
  }

  /**
   * Gets list of accounts
   * Managed by user
   */
  getManagedAccounts() {
    const url = "/api/v3/user/managers/accounts.json";
    return this.makeRequest("get", url);
  }

  /**
   * Creates a Manage Request
   * Sent by owner of Family Account
   * Payload has Manager Email
   * List of Accounts to manage
   * Access Type
   */
  createManageInvite(payload) {
    const url = "/api/v3/user/managers/accounts.json";
    return this.makeRequest("post", url, payload);
  }

  /**
   * Accept Manage Request
   * Sent by Maanger
   */
  acceptManageInvite({ id }) {
    const url = `/api/v3/user/managers/accept/${id}.json`;
    return this.makeRequest("post", url);
  }

  /**
   * Reject Manage Request
   */
  rejectManageRequest({ id }) {
    const url = `/api/v3/user/managers/reject/${id}.json`;
    return this.makeRequest("post", url);
  }

  /**
   * Delete Request Sent
   * To Manage an Account
   */
  deleteManageRequest({ id }) {
    const url = `/api/v3/user/managers/delete/${id}.json`;
    return this.makeRequest("post", url);
  }

  /**
   * Resend Manage Request
   */
  resendManageRequest({ id }) {
    const url = `/api/v3/user/managers/resend/${id}.json`;
    return this.makeRequest("post", url);
  }

  /**
   * Returns list of banks added
   * by current logged in user
   */
  // fetchLinkedBankAccounts() {
  //   const url = `/api/v3/user/banks.json`;
  //   return this.makeRequest("get", url);
  // }

  /**
   * Return Amc fund list details
   */
  getAllAmcList() {
    const url = `/api/v3/funds/amc_list.json`;
    return this.makeRequest("get", url);
  }

  initiateRazorpayOrder(data) {
    const url = `/api/v3/pg.json`;
    return this.makeRequest("post", url, data);
  }
  

  verifyRazorpayPayment(data) {
    const url = `/api/v3/pg/${data.id}/verify.json`;
    return this.makeRequest("post", url, data);
  }

  createRazorPaySubscription(data) {
    const url = `/api/v3/subscription/create.json`;
    return this.makeRequest("post", url, data);
  }

  verifyRazorPaySubscription(data) {
    const url = `/api/v3/subscription/${data.subscription.subscription}/verify.json`;
    return this.makeRequest("post", url, data);
  }

  cancelRazorPaySubscription(data) {
    const url = `/api/v3/subscription/cancel.json`;
    return this.makeRequest("post", url, data);
  }

  // enableSubsriptionFeature(date) {
  //   const url = `/api/v3/subscription/enable_feature.json`
  //   return this.makeRequest("post", url, data);
  // }

  /**
   * Return the exit load details for the user according to the holdins data
   * fund code and folio number
   */
  getExitLoad(data) {
    const url = "/api/v3/portfolio/transaction_details.json";
    return this.makeRequest("get", url, data);
  }

  getTaxHarvesting() {
    const url = '/api/v3/taxharvesting.json';
    return this.makeRequest('get', url);
  }

  harvestTax(orders) {
    const url = '/api/v3/taxharvesting/harvest.json';
    return this.makeRequest('post', url, orders);
  }

  getTaxHarvestHistory () {
      const url = '/api/v3/taxharvesting/history.json';
      return this.makeRequest('get', url);
  }
  getFeatureBlog(){
    const url = '/wp-json/wp/v2/posts?categories=158';
    return this.makeRequest('get', url);
  }
 
  getTopPostBlog(){
    const url = '/wp-json/wp/v2/posts?per_page=5';
    return this.makeRequest('get', url);
  }

  getBlogImage(imageList){
    const url = `/wp-json/wp/v2/media/?include=${imageList}`;
    return this.makeRequest('get', url);
  }

  getBlog(idList){
    const url = `/wp-json/wp/v2/posts/?include=${idList}`;
    return this.makeRequest('get', url);
  }
  
  getNotifications () {
    const url = '/api/v3/user/notifications.json' 
    return this.makeRequest('get', url);
  }
  
  updateNotification ({ id }) {
    const url = `/api/v3/user/notifications/${id}.json`
    return this.makeRequest('post', url);
  }
  
  getSubscriptions () {
    const url = '/api/v3/subscription.json'
    return this.makeRequest('get', url)
  }
  updateSubscription ({ id, data }) {
    const url = `/api/v3/subscriptions/${id}.json`
    return this.makeRequest('put', url, data)
  }

  ckycData(status){
    let url = `/admin/adfes433fkdfggs343434/ckyc.json?status=${status}`
    return this.makeRequest('get', url)
  }

  ckycImagesData(payload,images_required){
    let url = `/admin/adfes433fkdfggs343434/ckyc/${payload.id}.json?images_required=${images_required}`
    return this.makeRequest('get', url)
  }

  ckycUpdate(payload,data){
    let url = `/admin/adfes433fkdfggs343434/ckyc/${payload.id}.json`
    return this.makeRequest("put", url, data);
  }

  kycData(api){
    let url = `/admin/adfes433fkdfggs343434/kyc/${api}.json`
    return this.makeRequest('get', url)
  }

  kycDataId(id){
    let url = `/admin/adfes433fkdfggs343434/kyc/${id}.json`
    return this.makeRequest('get', url)
  }

  cvlUpdate(kycId, data){
    let url = `/admin/adfes433fkdfggs343434/kyc/${kycId}/cvl_update.json`
    return this.makeRequest("put", url, data);
  }


}

function delay(t, v) {
  return new Promise(function(resolve) {
    setTimeout(resolve.bind(null, v), t);
  });
}

// function retryFailedRequest(err) {
//   if (err.config && !err.config.__isRetryRequestCount) {
//     err.config.__isRetryRequestCount = 0;
//   }
//   if (
//     (!err.response || err.response.status >= 500) &&
//     err.config &&
//     err.config.__isRetryRequestCount < 5
//   ) {
//     err.config.__isRetryRequestCount += 1;
//     Vue.console.info(
//       "retrying a failed request " + err.config.__isRetryRequestCount
//     );
//     return delay(1000).then(() => axios(err.config));
//   }
//   throw err;
// }

function plugin(Vue) {
  if (plugin.installed) {
    return;
  }
  plugin.installed = true;

  // Declare Vue variable kuvera
  Vue.kuvera = new Kuvera();

  // Disabling retry logic until we figure out how to handle it correctly.
  // if (process.env.NODE_ENV == 'production') {
  //   Vue.prototype.$http.interceptors.response.use(undefined, retryFailedRequest);
  // }

  // Declare vueAuth as global variable for Vue
  Vue.vueAuth = new VueAuthenticate(Vue.prototype.$http, {
    baseUrl: Vue.config.EL_DORADO_API_URL + "/api/v3/users/", // Your API domain
    // loginUrl: "/authenticate.json",
    // registerUrl: "/register.json",
  
    providers: {
      google: {
        clientId: Vue.config.GOOGLE_CLIENTID,
        redirectUri: window.location.origin + "/auth/callback" // Your client app URL
      },
      // facebook: {
      //   clientId: Vue.config.FACEBOOK_CLIENTID,
      //   redirectUri: window.location.origin + "/auth/callback", // Your client app URL
      //   authorizationEndpoint: "https://www.facebook.com/v2.12/dialog/oauth"
      // }
    }
  });
}

function changed_auth_token() {
  return (
    store.state.user_token && Vue.vueAuth.getToken() != store.state.user_token
  );
}

export default plugin;
